import React from 'react';

export const SettingsUsersFormFeedback = ({ error = '', successMessage = '' }) => {
    return (
        <>
            {error && <div className="alert alert-danger py-2" role="alert">{error}</div>}
            {successMessage && <div className="alert alert-success py-2" role="alert">{successMessage}</div>}
        </>
    );
};
